import { AxiosResponse } from "axios";
import axiosInstance from "@lib/axios";
import { UserDataResponse } from "../types";

export const getInfo = async (): Promise<UserDataResponse> => {
    const { data }: AxiosResponse<UserDataResponse> = await axiosInstance.get("/user/info");

    return data;
};
